import React from 'react';
import {connect} from 'react-redux';
//@ts-ignore
import bt_tool_pairing from "@Images/en/bt_tool-pairing.png";
import {AppState} from "@Redux/store";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

const MyDraftsComponent: React.FC<MyDraftsComponentProps> = ({drafts}) => {

  return (
    <section>
      <div>
        <h2 className="text-center"><FormattedMessage {...defaultMessages.toolPairingDraftIndexTitle} /></h2>
        <div className="content row justify-content-center">
          <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2 army_list_row">
            <a href={`/${document.documentElement.lang}/tool/pairing/drafts/new`}>
              <img src={`${process.env.CDN ?? ''}${bt_tool_pairing}`} className="img-fluid w-100" alt=''/>
              <h4 className="boxtitre"><FormattedMessage {...defaultMessages.homeWhoareweDraft} /></h4>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (_: AppState) => {
  return {
    drafts: [],
  }
}

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MyDraftsComponent);

type MyDraftsComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
